(() => {
  'use strict';

  const GIFT_PROPERTY = '_bts_ease_gift';
  const GIFT_VALUE = 'Back to School gift';

  let cleaning = false;
  let queuedCleanup = false;

  const isTaggedBtsGift = (item) => item.properties?.[GIFT_PROPERTY] === GIFT_VALUE;

  const cartRequest = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) throw new Error(`BTS cart cleanup failed: ${response.status}`);
    return response.json();
  };

  const refreshCartDisplay = () => {
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: false }
    }));
  };

  const cleanupTaggedGift = async () => {
    if (cleaning) {
      queuedCleanup = true;
      return;
    }

    cleaning = true;
    let changed = false;

    try {
      const cartUrl = window.theme?.routes?.cart_url || '/cart.js';
      const cartChangeUrl = window.theme?.routes?.cart_change_url || '/cart/change.js';
      const cart = await fetch(cartUrl, {
        headers: { Accept: 'application/json' }
      }).then((response) => response.json());

      const taggedGiftLines = cart.items.filter(isTaggedBtsGift);

      for (const item of taggedGiftLines) {
        await cartRequest(cartChangeUrl, {
          id: item.key,
          quantity: 0
        });
        changed = true;
      }

      if (changed) refreshCartDisplay();
    }
    catch (error) {
      console.warn('[BTS cleanup] Tagged gift removal failed.', error);
    }
    finally {
      cleaning = false;

      if (queuedCleanup) {
        queuedCleanup = false;
        window.setTimeout(cleanupTaggedGift, 50);
      }
    }
  };

  const initialize = () => {
    cleanupTaggedGift();

    if (window.theme?.pubsub?.subscribe) {
      window.theme.pubsub.subscribe(
        window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        () => window.setTimeout(cleanupTaggedGift, 80)
      );
    }

    document.addEventListener('cart:updated', () => {
      window.setTimeout(cleanupTaggedGift, 80);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
  else {
    initialize();
  }
})();
